import clsx from "clsx";

type Props = {
	children?: React.ReactNode;
	bold?: boolean;
};

const InvoiceTotalsDetailValue = ({ bold = false, children }: Props) => {
	return <div className={clsx("flex items-center", bold ? "font-bold" : "")}>
		<div className="grow">
			{children}
		</div>
		<span className="ml-1 shrink text-sm">€</span>
	</div>;

};

export default InvoiceTotalsDetailValue;